import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getNotificationMessagesService() {
  return axios
    .get(`${BASE_URL}/getNotificationMessages`)
    .then(({ data }) => data);
}

export function setNotificationMessagesSeenService(notifications) {
  return axios
    .post(`${BASE_URL}/setNotificationMessagesSeen`, {
      notifications,
    })
    .then(({ data }) => data);
}
